import { useAuth0 } from "@auth0/auth0-react";
import { LoadingSpinner } from "components/LoadingSpinner";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoginMutation } from "store/queries/auth";
import { onTokenChange } from "store/slices/auth";

export interface ILoginPageProps {
  returnTo?: string;
}

export function LoginPage({ returnTo }: ILoginPageProps): JSX.Element {
  const {
    isLoading,
    isAuthenticated,
    loginWithRedirect,
    getAccessTokenSilently,
  } = useAuth0();

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [login] = useLoginMutation();

  const getToken = async () => {
    const token = await getAccessTokenSilently();

    dispatch(onTokenChange({ token }));
  };

  useEffect(() => {
    if (isAuthenticated) {
      getToken();

      // Get redirect path from location state first, then fallback to props and default
      const redirectPath = location.state?.returnTo || returnTo || "/";

      navigate(redirectPath);
      return;
    }

    if (isLoading || isAuthenticated) {
      return;
    }

    if (!isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: window.location.pathname },
      });
    }
  }, [isAuthenticated, loginWithRedirect, isLoading, login]);

  return <LoadingSpinner />;
}
